<a class="secondary-logo" [routerLink]="homeRoute" aria-label="Go to home page">
  <app-icon class="secondary-logo__icon" [icon]="IconName.SECONDARY_LOGO" />
</a>
